<script>
import { mapActions } from 'vuex'

export default {
  created () {
    if (this.$route.query.redirect) this.redirect = this.$route.query.redirect
  },
  data: () => ({
    redirect: '/',
    form: { email: '', senha: '' }
  }),
  methods: {
    ...mapActions({
      storeLogin: 'auth/login',
      toaster: 'modal/toaster'
    }),
    async login () {
      try {
        await this.storeLogin(this.form)
        this.$parent.close()
        window.location = this.redirect
      } catch (e) {
        this.toaster({ message: e.message, color: 'error' })
      }
    }
  }
}
</script>

<template>
  <form @submit.prevent="login">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Controle de Acesso | Login</p>
      </header>
      <section class="modal-card-body">
          <b-field label="Email">
            <b-input
              ref='email'
              v-model="form.email"
              type="email"
              :value="form.email"
              placeholder="Digite seu e-mail"
              required>
            </b-input>
          </b-field>
          <b-field label="Senha">
            <b-input
              ref='senha'
              v-model="form.senha"
              type="password"
              :value="form.senha"
              password-reveal
              placeholder="Digite sua senha"
              required>
            </b-input>
          </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" type="submit">Logar-se</button>
      </footer>
    </div>
  </form>
</template>
